import url from './apiUrl'
import handleResponse from './handleResponse'


export default (token, payload, userId) => {

    payload.append('userId', userId)

    return fetch(`${url()}/posts/save`, {
                method: 'POST',
                headers: {
                    "Authorization": token
                },
                body: payload
            })
            .then( res => handleResponse(res))
            .catch( err => console.log(err))
}